import store from '@/store'
window.CRVideo_LoginSuccess.callback = (UID, cookie) => {
  const { resolve, nickName } = cookie
  resolve({
    UID,
    nickName
  })
}

window.CRVideo_LoginFail.callback = (errCode, cookie) => {
  const { reject } = cookie
  reject(errCode)
}

export const SDKInit = {
  isInit: false,
  init () {
    window.CRVideo_SetSDKParams({ isSDKConsole: false })
    if (this.isInit) {
      return Promise.resolve()
    }
    return window.CRVideo_Init({
      // isCallSer: false,
      isUploadLog: false
    })
      .then(() => {
        // 初始化成功
        this.isInit = true
        // window.CRVideo_SDKParams({ isSDKConsole: false })
      })
      .catch((err) => {
        this.isInit = true
        throw err
      })
  },
  // 登录
  Login ({ AppId, MD5_AppSecret }) {
    return new Promise((resolve, reject) => {
      const UID = store.getters.userInfo.id || Math.random()
      const nickName = store.getters.userInfo.departmentName || store.getters.userInfo.name || 'test'
      window.CRVideo_Login(AppId, MD5_AppSecret, nickName, UID, undefined, {
        AppId,
        MD5_AppSecret,
        nickName,
        resolve,
        reject
      })
    })
  },
  // 登录
  Logout () {
    window.CRVideo_Logout()
  }
}
